import { checkForSignedInConnection } from '../../arcGIS/arcgis-connection-checker';

const ArcGISLogout = async (esriApiKey: string, connectors: any[], callback: () => void) => {
  const connection = await checkForSignedInConnection(esriApiKey, connectors, false);
  if (connection) {
    connection.destroyCredentials();
  }
  callback();
};

export default ArcGISLogout;
